<div class="map-wrap">
  <div class="map" #map></div>
</div>